export default {
    methods: {
        getNameById(arr, nameKey, idKey, id) {
            const item = arr.find(el => {
                if (el[idKey] == id) {
                    return el
                }
            })

            return item ? item[nameKey] : ''
        }
    }
}
